import { RouteObject } from "react-router";
import FieldsCrumb from "./FieldsCrumb";
import { getTaskmapHistoryEntries } from "../../../../API/fields";

const routes: RouteObject = {
  id: "fields",
  path: "fields",
  loader: getTaskmapHistoryEntries,
  handle: {
    Crumb: FieldsCrumb,
  },
};

export default routes;
